import { LocalizedPageTitle, LocalizedParagraph } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { NewPublicFormWrapper } from '../style';

export type Configure2FALayoutProps = React.PropsWithChildren<{
    title: Mews.TextKey;
    subtitle?: Mews.TextKey;
    extra?: React.ReactNode;
}>;

export function Configure2FALayout({ title, subtitle, extra, children }: Configure2FALayoutProps) {
    return (
        <NewPublicFormWrapper vertical>
            <Stack spacing="500" vertical>
                <Stack spacing="100" vertical>
                    <LocalizedPageTitle textKey={title} />
                    {subtitle && <LocalizedParagraph textKey={subtitle} variant="secondary" />}
                    {extra}
                </Stack>
                {children}
            </Stack>
        </NewPublicFormWrapper>
    );
}
